module.exports = __webpack_public_path__ + "static/cag6-36cbfbd4ee7a8febb6cb6c1a08142d62.png";